"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _const = require("./const");

var _utils = require("./utils");

var _Icon = _interopRequireDefault(require("../Icon"));

require("./Avatar.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Avatar = function Avatar(_ref) {
  var shape = _ref.shape,
      src = _ref.src,
      iconType = _ref.iconType,
      name = _ref.name,
      gap = _ref.gap,
      withSecondName = _ref.withSecondName,
      alt = _ref.alt,
      size = _ref.size,
      className = _ref.className,
      onError = _ref.onError,
      props = _objectWithoutProperties(_ref, ["shape", "src", "iconType", "name", "gap", "withSecondName", "alt", "size", "className", "onError"]);

  var avatarSrc = src && 'avatar-image';
  var avatarType = _const.avatarTypes[shape] || _const.avatarTypes.circle;
  var avatarNodeRef = (0, _react.useRef)();
  var avatarChildrenRef = (0, _react.useRef)();

  var calcAvatarFontSize = function calcAvatarFontSize(size) {
    var defaultFontSize = (0, _utils.getFontSize)(avatarNodeRef.current);

    if (size < defaultFontSize + gap * 2) {
      avatarNodeRef.current.style.fontSize = "".concat(defaultFontSize - gap * 2, "px");
    }
  };

  var calculateSizeClass = function calculateSizeClass() {
    if (size in _const.avatarSizeTypes) {
      return _const.avatarSizeTypes[size].className;
    }

    return '';
  };

  var calculateSizeStyles = function calculateSizeStyles() {
    if (size in _const.avatarSizeTypes) {
      calcAvatarFontSize(_const.avatarSizeTypes[size].px);
    } else if (typeof size === 'number' && size >= 0) {
      calcAvatarFontSize(size);
      avatarNodeRef.current.style.width = "".concat(size, "px");
      avatarNodeRef.current.style.height = "".concat(size, "px");
      avatarNodeRef.current.style.lineHeight = "".concat(size, "px");
      avatarChildrenRef.current.style.lineHeight = "".concat(size, "px");
    }
  };

  var renderContent = function renderContent() {
    if (src) {
      return /*#__PURE__*/_react.default.createElement("img", {
        src: src,
        alt: alt,
        onError: onError
      });
    }

    if (iconType) {
      return /*#__PURE__*/_react.default.createElement(_Icon.default, {
        type: iconType
      });
    }

    if (name) {
      return (0, _utils.getInitialsByName)(name, withSecondName);
    }

    return null;
  };

  (0, _react.useEffect)(function () {
    calculateSizeStyles();
  }, []);
  return /*#__PURE__*/_react.default.createElement("span", _extends({
    ref: avatarNodeRef,
    className: "Avatar ".concat(className, " ").concat(avatarType, " ").concat(avatarSrc, " ").concat(calculateSizeClass())
  }, props), /*#__PURE__*/_react.default.createElement("span", {
    ref: avatarChildrenRef,
    className: "avatar-content"
  }, renderContent()));
};

Avatar.propTypes = {
  /** The shape of avatar circle | square */
  shape: _propTypes.default.oneOf(['circle', 'square']),

  /** Icon type for an icon avatar */
  iconType: _propTypes.default.string,

  /** The size of the avatar number or 'large', 'small', 'default' */
  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['large', 'small', 'default'])]),

  /** the address of the image for an image avatar */
  src: _propTypes.default.string,

  /** This attribute defines the alternative text describing the image */
  alt: _propTypes.default.string,

  /** Link text (default set to 'Logout') */
  gap: _propTypes.default.number,

  /** handler when img load error, return false to prevent default fallback behavior */
  onError: _propTypes.default.func,

  /** initial with SecondName */
  withSecondName: _propTypes.default.bool,

  /** name for initial  */
  name: _propTypes.default.string,

  /** @ignore */
  className: _propTypes.default.string
};
Avatar.defaultProps = {
  shape: 'circle',
  iconType: null,
  size: 'default',
  src: '',
  alt: '',
  gap: 4,
  withSecondName: false,
  name: '',
  className: '',
  onError: function onError() {}
};
var _default = Avatar;
exports.default = _default;